import CpApiService from '../abstracts/cp-api.service';

export default class TechnicalSupportService extends CpApiService {
  static async getTechnicalSupportUrl(technicalSupportUrl: string, accessToken: string, projectNumber: string): Promise<string> {
    const result = await this.fetch<{ url: string }>(accessToken, `${technicalSupportUrl}/releases/launch?release_code=${projectNumber}`);
    return result.url;
  }
}
